import { Link } from "react-router-dom"
import AuthLayout from "../../../components/layouts/auth"
import { Eye, UserRoundPen } from "lucide-react"
import ApiRequest from "../../../lib/ApiCall"
import { useEffect, useState } from "react"
import PaginationType from "../../../types/pagination-type"
import TablePagination from "../../../components/table/table-pagination"
import InputField from "../../../components/form/input-field"

const Members = () => {

    type MembersType = {
        uuid: string,
        logo: string,
        websiteUrl: string,
        contactAddress: string,
        contactRepresentatives: [],
        secRegistrationNumber: string,
        status: string,
        nameInstitution: string,

    };

    const [members, setMembers] = useState<MembersType[]>([]);

    const [data, setData] = useState<PaginationType>({} as PaginationType);

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [search, setSearch] = useState<string>("");
    const [debouncedSearch, setDebouncedSearch] = useState<string>("");

    // debounce search
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
            setCurrentPage(1); // reset page on new search
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    const getMembers = async () => {
        const request = await ApiRequest({ endpoint: `member?page=${currentPage}&search=${debouncedSearch}`, method: 'GET' });
        if (request.status !== '200') return;
        setMembers(request.data.items);
        setData(request.data);
    }

    useEffect(() => { getMembers() }, [currentPage, debouncedSearch]);

    return (
        <AuthLayout>
            <div>
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="page-title">Members</h1>
                        <p className="text-sm italic font-light text-gray-700">
                            total members {data.total}
                        </p>
                    </div>

                    <div className="flex gap-3 items-center">
                        <div >
                            <InputField
                                label="" style={{ minWidth: '300px' }}
                                placeholder="Search by name or Sec ID"
                                type="text"
                                onChangeInput={(e) => setSearch(e.target.value)}
                                value={search}
                            />
                        </div>

                        <Link to="/members/create" className="pryBtn">
                            + Add Member
                        </Link>
                    </div>
                </div>
                <div className='relative overflow-x-auto'>
                    <table className='mt-5 text-tertiary font-[500] text-[14px] w-full relative z-10'>
                        <thead>
                            <tr className='border-b border-[#E6EAF0] bg-[#fafafa]'>
                                {/* <td className="px-4 py-3">SN</td> */}
                                <td className="px-4 py-3">Logo</td>
                                <td className="px-4 py-3">Institution Name</td>
                                <td className="px-6 py-3">SEC Reg. Number</td>
                                <td className="px-6 py-3 text-center">Number of representatives</td>
                                <td className="px-6 py-3 text-center">Status</td>
                                <td className="px-6 py-3 text-center">Action</td>
                            </tr>
                        </thead>
                        <tbody className="relative">
                            {members?.map((member, i) => (
                                <tr key={i} className='border-b border-[#E6EAF0]'>
                                    {/* <td className="px-6 py-3">{member.uuid}</td> */}

                                    <td className="px-4 py-3 capitalize">
                                        {member.logo && (
                                            <img style={{ width: '50px' }}
                                                src={member.logo}
                                                alt="logo"
                                                className=" inset-0 w-full h-full object-contain"
                                            />
                                        )}
                                    </td>
                                    <td className="px-4 py-3 capitalize">
                                        <div>{member.nameInstitution}</div>
                                        <small>{member.websiteUrl}</small>
                                    </td>
                                    <td className="px-6 py-3">{member.secRegistrationNumber}</td>
                                    <td className="px-6 py-3 text-center">{member.contactRepresentatives.length}</td>
                                    <td className={`px-6 py-3 text-xs text-center uppercase ${member.status === 'active' ? 'text-green-500' : 'text-red-500'}`}>{member.status}</td>
                                    <td className="px-6 py-3 text-center">
                                        <Link to={`/members/${member.uuid}`} className="pryBtn">
                                            <span><Eye size={18} /></span>
                                            <span>Preview</span>
                                        </Link>
                                        <Link to={`/members/${member.uuid}/edit`} className="pryBtnOutline text-wrap w-fit mt-2" type="button">
                                            <UserRoundPen size={18} />
                                            <span>Edit account</span>
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* pagination */}
                <div className="mt-5">
                    <TablePagination
                        currentPage={currentPage}
                        totalPages={data.totalPages ?? 0}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                </div>
            </div>
        </AuthLayout>
    )
}

export default Members